'use client';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

import { ReactNode } from 'react';

interface Props {
  cacheKey: string;
  children: ReactNode;
}

const EmotionProvider = ({ cacheKey, children }: Props) => {
  const cache = createCache({ key: cacheKey.toLowerCase(), prepend: false });

  return <CacheProvider value={cache}>{children}</CacheProvider>;
};

export default EmotionProvider;
